import { createPermission } from '@backstage/plugin-permission-common';

export const accessRoleListPermission = createPermission({
  name: 'access.role.list',
  attributes: {
    action: 'read',
  },
});

export const accessRoleCreatePermission = createPermission({
  name: 'access.role.create',
  attributes: {
    action: 'create',
  },
});

export const accessRoleUpdatePermission = createPermission({
  name: 'access.role.update',
  attributes: {
    action: 'update',
  },
});

export const accessRoleDeletePermission = createPermission({
  name: 'access.role.delete',
  attributes: {
    action: 'delete',
  },
});

export const accessBindingListPermission = createPermission({
  name: 'access.binding.list',
  attributes: {
    action: 'read',
  },
});

export const accessBindingCreatePermission = createPermission({
  name: 'access.binding.create',
  attributes: {
    action: 'create',
  },
});

export const accessBindingUpdatePermission = createPermission({
  name: 'access.binding.update',
  attributes: {
    action: 'update',
  },
});

export const accessBindingDeletePermission = createPermission({
  name: 'access.binding.delete',
  attributes: {
    action: 'delete',
  },
});

export const accessReconcileRunPermission = createPermission({
  name: 'access.reconcile.run',
  attributes: {},
});

export const accessReconcileReadPermission = createPermission({
  name: 'access.reconcile.read',
  attributes: {
    action: 'read',
  },
});

export const accessReconcileCleanPermission = createPermission({
  name: 'access.reconcile.clean',
  attributes: {},
});

export const accessAuditLogListPermission = createPermission({
  name: 'access.audit-log.list',
  attributes: {
    action: 'read',
  },
});

export const accessPermissions = [
  accessRoleListPermission,
  accessRoleCreatePermission,
  accessRoleUpdatePermission,
  accessRoleDeletePermission,
  accessBindingListPermission,
  accessBindingCreatePermission,
  accessBindingUpdatePermission,
  accessBindingDeletePermission,
  accessAuditLogListPermission,
  accessReconcileReadPermission,
  accessReconcileRunPermission,
  accessReconcileCleanPermission,
];
